module.exports = __webpack_public_path__ + "img/title.c1c8ec3a.png";